































import { Vue, Component } from 'vue-property-decorator';
import * as RaceService from '../services/RaceService';
import PartialRaceData from '../types/PartialRaceData';

@Component
export default class Race extends Vue {
  raceList: PartialRaceData[] = null;

  async mounted() {
    const raceList = await RaceService.getAllRaces();
    console.log(raceList);
    this.raceList = raceList;
  }
}
